import { render } from "./ChartBoundaries.vue?vue&type=template&id=497e3f99"
import script from "./ChartBoundaries.vue?vue&type=script&lang=js"
export * from "./ChartBoundaries.vue?vue&type=script&lang=js"
script.render = render

export default script